import { extractYoutubeId, shouldUseNativeVideoPlayer, youtubeIframeEmbedSrc } from '../lib/media-url';
import { attachFcMediaStartOverlay } from './fc-media-start-overlay';
import { initFcVideoJs } from './fc-video-player';

function sourceTypeForUrl(url: string): string {
  if (/\.webm/i.test(url)) {
    return 'video/webm';
  }
  if (/\.ogg/i.test(url)) {
    return 'video/ogg';
  }
  return 'video/mp4';
}

export function initFcMediaEmbedUrls(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>('[data-fc-media-embed-url]').forEach((container) => {
    const url = container.dataset.fcMediaEmbedUrl?.trim();
    if (!url || container.dataset.fcMediaEmbedDone === '1') {
      return;
    }
    container.dataset.fcMediaEmbedDone = '1';

    const embedKind = container.dataset.fcMediaEmbedKind?.trim();

    const yt = extractYoutubeId(url);
    if (yt) {
      const iframe = document.createElement('iframe');
      iframe.className = 'fc-youtube__iframe';
      iframe.src = youtubeIframeEmbedSrc(yt);
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute(
        'title',
        container.dataset.fcMediaEmbedIframeTitle?.trim() || 'YouTube player',
      );
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
      );
      container.appendChild(iframe);
      attachFcMediaStartOverlay(container);
      return;
    }

    if (shouldUseNativeVideoPlayer(url, embedKind)) {
      const vid = document.createElement('video');
      vid.className = 'video-js';
      vid.dataset.fcVjs = '';
      vid.dataset.fcPlayer = 'full';
      vid.controls = true;
      vid.preload = 'metadata';
      const source = document.createElement('source');
      source.src = url;
      source.type = sourceTypeForUrl(url);
      vid.appendChild(source);
      container.appendChild(vid);
      initFcVideoJs(container);
      attachFcMediaStartOverlay(container);
      return;
    }

    const err = document.createElement('p');
    err.className = 'fc-media__error';
    err.setAttribute('role', 'alert');
    err.textContent =
      container.dataset.fcMediaEmbedUnsupported?.trim() || 'Unsupported video URL.';
    container.appendChild(err);
  });
}
